import * as React from 'react';
import Helmet from 'react-helmet';

import { GatsbyTopLayout } from './gatsby-top-layout';

export const wrapRootElement = ({ element }) => (
  <React.Fragment>
    <Helmet>
      <script
        src="https://kit.fontawesome.com/c6b441b30b.js"
        crossOrigin="anonymous"
      ></script>
    </Helmet>
    <GatsbyTopLayout>{element}</GatsbyTopLayout>
  </React.Fragment>
);
